export default "__VITE_ASSET__a8b27dae__"